import { RootState } from '../store';
import { CashierModal } from './types';

export const cashierModal = (state: RootState): CashierModal => state.cashier?.cashierModal;
